export const referral_num_needed = 10;

export const required_num_labels = 4000;